import LoginModal from './src/LoginModal';

export default LoginModal;
